/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
// Please just use the pointer class .pointer
export const style = {
    clickable: css`text-decoration: underline; cursor:pointer`,
};
